'use client';

import classNames from 'classnames';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import DynamicButton from '@alltrails/denali/components/DynamicButton';
import type { ConditionStyleId } from '@alltrails/maps/types/Styles';
import groundConditionsSrc from './images/groundConditions.avif';
import precipitationSrc from './images/precipitation.avif';
import snowDepthSrc from './images/snowDepth.avif';
import temperatureSrc from './images/temperature.avif';
import styles from './ConditionsWeatherMapButton.module.scss';

type ConditionsWeatherMapButtonProps = {
  className?: string;
  condition: ConditionStyleId;
  onClick: () => void;
};

const ConditionsWeatherMapButton = ({ className, condition, onClick }: ConditionsWeatherMapButtonProps) => {
  const src = useMemo(() => {
    switch (condition) {
      case 'groundConditions':
        return groundConditionsSrc;
      case 'precipitation':
        return precipitationSrc;
      case 'snowDepth':
        return snowDepthSrc;
      case 'temperature':
      default:
        return temperatureSrc;
    }
  }, [condition]);

  return (
    <DynamicButton
      className={classNames(styles.mapButton, className)}
      src={src.src}
      onClick={onClick}
      text={<FormattedMessage defaultMessage="Weather map" />}
    />
  );
};

export default ConditionsWeatherMapButton;
